import { render } from "./OriginsCard.vue?vue&type=template&id=3cb3d0fc"
import script from "./OriginsCard.vue?vue&type=script&lang=js"
export * from "./OriginsCard.vue?vue&type=script&lang=js"
script.render = render

export default script